export default __webpack_public_path__ + "static/media/ArrowDown.db476cd3.svg";